// extracted by mini-css-extract-plugin
export default {"container":"ScrollingText_container__cHRVS","scrollable":"ScrollingText_scrollable__acsAN","scroll":"ScrollingText_scroll__tqGSO"};